import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Analytics from "@/components/Analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ProductsIndex from "@/pages/ProductsIndex";
import ProductDetail from "@/pages/ProductDetail";
import CustomPackaging from "@/pages/CustomPackaging";
import Industries from "@/pages/Industries";
import Clients from "@/pages/Clients";
import RequestQuote from "@/pages/RequestQuote";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Analytics />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<ProductsIndex />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/custom-packaging" element={<CustomPackaging />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/request-a-quote" element={<RequestQuote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
